import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import MessagesComp from "../../../components/usersettings/messagescomp";

export default function Messages() {
  return (
    <>
      <UserProfileLayout>
        <div className="w-full bg-white rounded-2xl border border-primary50 justify-start gap-4 flex p-8 mb-4">
          <MessagesComp />
        </div>
      </UserProfileLayout>
    </>
  );
}
